import * as types from '../../mutation-types'
import axios from "axios";

export const fetchAdminData = async ({ commit }) => {
    try {
        const { data } = await axios.get(process.env.API_URL + '/admin')
        commit(types.FETCH_ADMIN_DATA_SUCCESS, { data })
    } catch (e) {
        commit(types.FETCH_ADMIN_DATA_FAILURE)
    }
};

export const fetchRegimenData = async ({ commit }) => {
    try {
        const { data } = await axios.get(process.env.API_URL + '/admin-all-regimens')
        commit(types.FETCH_REGIMEN_DATA_SUCCESS, { data })
    } catch (e) {
        commit(types.FETCH_REGIMEN_DATA_FAILURE)
    }
};

export const deleteUsers = async ({ commit }, user) => {
    try {
        await axios.post(process.env.API_URL + '/delete-user', user);
        commit(types.FETCH_DELETE_USER_SUCCESS, user)
    } catch (e) {
        commit(types.FETCH_DELETE_USER_FAILURE)
    }
};

export const adminAddUsers = async ({ commit, dispatch }, formData) => {
       await formData.post(process.env.API_URL + '/admin-add-user');
       dispatch('fetchAdminData')
}

export const adminEditUser = ({ commit, dispatch }, formData) => {
    try {
        const { data } = formData.post(process.env.API_URL + '/admin-edit-user');
        commit(types.EDIT_USER_SUCCESS)
        dispatch('fetchAdminData')
    } catch (e) {
        commit(types.EDIT_USER_FAILURE)
    }
}

export const getAllRoles = async ({ commit }) => {
    try {
        const {data} = await axios.get(process.env.API_URL + '/get-roles');
        commit(types.FETCH_ROLES_SUCCESS, data)
    } catch (e){
        commit(types.FETCH_ROLES_FAILURE)
    }
}

export const getUser = async ({ commit }, userId) => {
    try{
        const { data } = await axios.get(process.env.API_URL + '/get-user/' + userId)
        commit(types.FETCH_USER_INFO_SUCCESS, data)
    } catch (e){
        console.log(e)
    }
}

export const getAllNotes = async ({ commit }) => {
    try {
        const { data } = await axios.get(process.env.API_URL + '/get-all-notes')
        commit(types.FETCH_ALL_NOTES_SUCCESS, data)
    } catch (e) {
        console.log(e)
    }
}

export const getAllInsight = async ({commit}) => {
    try {
        const { data } = await axios.get(process.env.API_URL + '/get-all-insight')
        commit(types.FETCH_ALL_INSIGHT_SUCCESS, data)
    } catch (e){
        console.log(e)
    }
}

export const saveInsightData = async ({ commit, dispatch }, formData) => {
    await formData.post(process.env.API_URL + '/save-insight')
    dispatch('getAllInsight')
}

export const saveRegimenData = async ({ commit, dispatch }, formData) => {
    await formData.post(process.env.API_URL + '/admin-add-regimens')
    dispatch('fetchRegimenData')
}

export const deleteRegimen = async ({ commit }, ID) => {
    try {
        await axios.delete(process.env.API_URL + `/admin-delete-regimens/${ID}`);
        commit(types.FETCH_DELETE_REGIMEN_SUCCESS, ID)
    } catch (e) {
        commit(types.FETCH_DELETE_REGIMEN_FAILURE)
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/admin/actions.js